import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { recursionProblems } from '../../data/practice/recursionProblems';
import ProblemLayout from '../../components/ProblemLayout';

const RecursionProblem: React.FC = () => {
  const { problemId } = useParams<{ problemId: string }>();
  const problem = recursionProblems.find(p => p.id === problemId);
  const [code, setCode] = useState(problem?.starterCode || '');

  if (!problem) {
    return (
      <div className="min-h-screen bg-[#282c34] text-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-semibold mb-4">Problem not found</h1>
          <button
            onClick={() => window.location.href = '/practice/recursion'}
            className="px-4 py-2 bg-[#1e2127] rounded-lg hover:bg-[#3e4451] transition-colors"
          >
            Back to Problems
          </button>
        </div>
      </div>
    );
  }

  return (
    <ProblemLayout
      title={problem.title}
      difficulty={problem.difficulty}
      tags={problem.tags}
      description={problem.description}
      hints={problem.hints}
      code={code}
      onCodeChange={setCode}
      onResetCode={() => setCode(problem.starterCode || '')}
      backUrl="/practice/recursion"
      problemId={problemId || ''}
    />
  );
};

export default RecursionProblem;